import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Label } from 'reactstrap';
import { SwitchItem } from '../../../components';
import { getTranslationKey } from '../../../modules/utils/helpers';
import { getSequentialUploads } from '../../../modules/selectors';
import { updateSequentialUploadsAction } from '../../../modules/actions';

export const SequentialUploadsToggle: React.FC = () => {
  const dispatch = useDispatch();
  const sequentialUploads = useSelector(getSequentialUploads);

  return (
    <div className="mt-4">
      <Label className="font-weight-bold">
        {getTranslationKey('uploadEndpoint.disableConcurrentLabel')}:
      </Label>
      <p>{getTranslationKey('uploadEndpoint.disableConcurrentDescription')}</p>
      <SwitchItem
        id="sequentialUploads"
        value={sequentialUploads}
        label={getTranslationKey('uploadEndpoint.disableConcurrentToggle')}
        direction="row-reverse"
        margin="0"
        changeCallback={(value) => dispatch(updateSequentialUploadsAction(value))}
      />
    </div>
  );
};
